import { Injectable } from '@angular/core';

import { EMPTY, Observable, of, race, timer } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { I18nService } from '@recruitee/i18n';
import {
  NotificationHostComponent,
  NotificationRef,
  NotificationsController,
} from '@recruitee/user-interface';

@Injectable({ providedIn: 'root' })
export class CancellableNotificationService {
  constructor(private notificationsCtrl: NotificationsController, private i18n: I18nService) {}

  public show(titleKey: string, delayMs: number): Observable<NotificationRef> {
    return new Observable<NotificationRef>(subscriber => {
      const cancellableNotification = this.notificationsCtrl.progress(
        {
          title: this.i18n.translate(titleKey),
          topButtonLabel: this.i18n.translate('rti.common.cancel'),
        },
        { timeout: 0, showClose: false },
      );

      subscriber.next(cancellableNotification);
    }).pipe(
      switchMap(notification => {
        const cancellation = notification
          .topButtonClick()
          .asObservable()
          .pipe(map(() => <const>'cancelled'));
        const delay = timer(delayMs).pipe(map(() => <const>'delayed'));

        return race(cancellation, delay).pipe(
          tap(reason => {
            if (reason === 'cancelled') {
              notification.close();
            } else {
              (<NotificationHostComponent>notification.hostRef.instance).data.topButtonLabel =
                undefined;
              notification.hostRef.changeDetectorRef.detectChanges();
            }
          }),
          switchMap(reason => (reason === 'cancelled' ? EMPTY : of(notification))),
        );
      }),
    );
  }
}
